import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  customizeTitle: {
    id: 'donater.form.customize.title',
    defaultMessage: 'Customize your donation',
  },
  addImage: {
    id: 'donater.form.add_image',
    defaultMessage: 'Add Image',
  },
  addVideo: {
    id: 'donater.form.add_video',
    defaultMessage: 'Add Video',
  },
  youtubeLink: {
    id: 'donater.form.youtube_link',
    defaultMessage: 'YouTube Link',
  },
  youtubeStart: {
    id: 'donater.form.youtube_start',
    defaultMessage: 'Start From',
  },
  youtubePlaceholder: {
    id: 'donater.form.youtube_placeholder',
    defaultMessage: 'https://youtube.com/....',
  },
  image: {
    id: 'donater.form.customize_media.image',
    defaultMessage: 'Image',
  },
  video: {
    id: 'donater.form.customize_media.video',
    defaultMessage: 'Video',
  },
  videoDurationDisclaimer: {
    id: 'donater.form.customize_media.video_duration_disclaimer',
    defaultMessage:
      'The video will be played for no longer than {duration} {duration, plural, one {minute} other {minutes}}.',
  },
  chooseImageTitle: {
    id: 'donater.form.customize_media.choose_image_title',
    defaultMessage: 'Choose Image',
  },
  chooseImageSubtitle: {
    id: 'donater.form.customize_media.choose_image_subtitle',
    defaultMessage: 'Add an image for your donation from our library.',
  },
})
